import type { Capabilities, SubscriptionDetail } from '@rtkwlf/rendall';

export const getDataExplorerFeatureReleases = (
  subscriptions: SubscriptionDetail | undefined,
  legacyCapabilities: Capabilities | undefined,
) => {
  if (!subscriptions || !legacyCapabilities) {
    return [];
  }

  return [];
};
